module.exports = __webpack_public_path__ + "img/remote.962d2040.png";